module.exports = __webpack_public_path__ + "static/media/icon-arrow-down-red.5dbe46b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-arrow-down-red.svg
// module id = 747
// module chunks = 0